import { render, staticRenderFns } from "./BaseSHPiao.vue?vue&type=template&id=d2687ac4&scoped=true&"
import script from "./BaseSHPiao.vue?vue&type=script&lang=js&"
export * from "./BaseSHPiao.vue?vue&type=script&lang=js&"
import style0 from "./BaseSHPiao.vue?vue&type=style&index=0&id=d2687ac4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2687ac4",
  null
  
)

export default component.exports